export default __webpack_public_path__ + "static/media/star-half.99d6283a.svg";